import { BeneficiaryKey } from "../../Benefit/beneficiary-key";

export class CardUnblockDTO {
  constructor(private readonly beneficiaryKey: BeneficiaryKey, private readonly includeDependents: boolean) {}

  getBeneficiaryKey(): BeneficiaryKey {
    return this.beneficiaryKey;
  }

  getIncludeDependents(): boolean {
    return this.includeDependents;
  }
}
